module.exports = __webpack_public_path__ + "static/media/business-asset-mgmt-chart-en.c7697ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/business-asset-mgmt-chart-en.png
// module id = 497
// module chunks = 0